/**
 * @generated SignedSource<<4c386a0d2a449d22ed7f601837494ff7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RouteConfig_ForgotPasswordPage_Query$variables = {
  customLandingHostname: string;
};
export type RouteConfig_ForgotPasswordPage_Query$data = {
  readonly viewer: {
    readonly customPortal: {
      readonly " $fragmentSpreads": FragmentRefs<"ForgotPasswordPage_customPortal">;
    } | null;
  };
};
export type RouteConfig_ForgotPasswordPage_Query = {
  response: RouteConfig_ForgotPasswordPage_Query$data;
  variables: RouteConfig_ForgotPasswordPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customLandingHostname"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "customLandingHostname",
    "variableName": "customLandingHostname"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RouteConfig_ForgotPasswordPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "CustomPortalNode",
            "kind": "LinkedField",
            "name": "customPortal",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ForgotPasswordPage_customPortal"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RouteConfig_ForgotPasswordPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "CustomPortalNode",
            "kind": "LinkedField",
            "name": "customPortal",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoImageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "footerImageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headerFontColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "faviconUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pageTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contactEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "19c31057d6bfff1e3871ace9f922966e",
    "id": null,
    "metadata": {},
    "name": "RouteConfig_ForgotPasswordPage_Query",
    "operationKind": "query",
    "text": "query RouteConfig_ForgotPasswordPage_Query(\n  $customLandingHostname: String!\n) {\n  viewer {\n    customPortal(customLandingHostname: $customLandingHostname) {\n      ...ForgotPasswordPage_customPortal\n      id\n    }\n  }\n}\n\nfragment ForgotPasswordPage_customPortal on CustomPortalNode {\n  logoImageUrl\n  footerImageUrl\n  customColor\n  headerFontColor\n  faviconUrl\n  pageTitle\n  contactEmail\n}\n"
  }
};
})();

(node as any).hash = "b89387d24593fadb93e1ad6626d2f848";

export default node;
